import { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import { SkillSchema } from "./schemas/skill.schema";

export const ZSkills = {
  /**
   * GET /api/tools/skills
   * Returns all AI tasks, external tools, and workflows for the organization.
   */
  GetAll: {
    method: "GET" as const,
    path: "/api/tools/skills",
    Response: ApiSuccessSchema(z.array(SkillSchema))
  }
} as const;
